import api from '@/core/apiclient'
import {actionTypes, mutationTypes} from '@/core/constants'

export default {

    async [actionTypes.COMUM.BUSCAR_DADOS_USUARIO_AUTENTICADO]({commit}) {
        const {data} = await api.usuario.buscarDadosDoUsuarioAutenticado()
        if (data) {
            commit(mutationTypes.COMUM.SET_USUARIO_LOGADO_UPDATE, data)
        }
    },

}